import httpClient from "./httpClient";

const prefix = "/deductions";

export async function saveDeduction(body: any) {
  return (await httpClient.post(`${prefix}`, body)).data;
}

export async function findDeductionByPartner(id: number) {
  return (await httpClient.get(`${prefix}/partner/${id}`)).data;
}

export async function findDeductionById(id: string) {
  return (await httpClient.get(`${prefix}/details/${id}`)).data;
}

export async function updateDeduction(id: string, body: any) {
  return (await httpClient.put(`${prefix}/${id}`, body)).data;
}

export async function findActiveDeductions(
  data: { start: string; end: string },
  signal?: AbortSignal
) {
  return (await httpClient.get(`${prefix}`, { params: data, signal })).data;
}